var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.wrapper)?_c('div',[_vm._t("default")],2):_c('li',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }